class BeautySleepBanner extends HTMLElement {
	constructor() {
		super();
		this.init();
	}

	init() {
		// Event listeners voor responsive gedrag
		this.handleResize();
		window.addEventListener('resize', this.handleResize.bind(this));
		
		// Accessibility verbeteringen
		this.initAccessibility();
	}

	handleResize() {
		// Responsive gedrag wordt nu gedaan via CSS
		// Dit kan uitgebreid worden voor meer complexe responsive gedrag
	}

	initAccessibility() {
		// Voeg ARIA labels toe voor betere toegankelijkheid
		const banner = this.querySelector('.beauty-sleep-banner');
		if (banner) {
			banner.setAttribute('aria-label', 'Beauty Sleep Essentials banner');
		}

		// Voeg rol toe aan bullet items
		const bulletItems = this.querySelectorAll('.beauty-sleep-banner__bullet-item');
		bulletItems.forEach((item, index) => {
			item.setAttribute('role', 'listitem');
			item.setAttribute('aria-label', `Feature ${index + 1}`);
		});
	}
}

// Registreer de custom element
customElements.define('beauty-sleep-banner', BeautySleepBanner);
